<template>
  <modify-apply-block
    data-type="worker_certificate_doctor_qua"
    ref="worker_certificate_doctor_qua_p"
    :getTitle="getTitle"
    :getEdit="getEdit"
    :saveEdit="saveEdit"
    :addEdit="addEdit"
    :form-parms-add="formParmsAdd"
    :dataFileParm="{docName: '职业资格证书', isDoc: true}"
    block-name="职业资格证书"
    @dataFileUpdate="dataFileUpdate"
    :init-add-form-data="initAddFormData"
    ref-name="worker_certificate_doctor_qua"
    :worker-id="workerId">
  </modify-apply-block>
</template>

<script>
import ModifyApplyBlock from './modifyApplyBlock'

import {
  workerCertificateRequest
} from '@/api'

import {
  dateOperating
} from '@/fmlib'

export default {
  components: {
    ModifyApplyBlock
  },
  data () {
    return {
      workerId: null
    }
  },
  created () {
    this.workerId = this.$router.history.current.query.workerId
  },
  beforeRouteLeave (to, from, next) {
    if (this.$refs['worker_certificate_doctor_qua_p'].openForm) {
      this.$refs['worker_certificate_doctor_qua_p'].openForm = false
      next(false)
    } else {
      next()
    }
  },
  methods: {
    async dataFileUpdate (parm, pageVm) {
      await workerCertificateRequest.update(pageVm.chooseData.id, {
        imgUploadTime: dateOperating.computeDay({days: 0, date: new Date(), format: 'yy-mm-dd hh:mm:ss'})
      })
      pageVm.loadData()
    },
    initAddFormData () {
      return {
        workerId: this.workerId,
        type: 'doctor_qua'
      }
    },
    async getEdit () {
      if (this.workerId) {
        return await workerCertificateRequest.getEdit({
          type: 'doctor_qua',
          workerId: this.workerId
        })
      }
    },
    async saveEdit (parm) {
      return await workerCertificateRequest.saveEdit(Object.assign({}, parm, {
        dataId: parm.id,
        id: undefined
      }))
    },
    async addEdit (parm) {
      return await workerCertificateRequest.addEdit(parm)
    },
    getTitle () {
      return '职业资格证书'
    }
  },
  computed: {
    formParmsAdd: {
      get () {
        let data = [{
          type: 'select',
          selectDatas: this.$store.getters.selectDatas['qualification_certificate_type'],
          label: '证书类型',
          key: 'xlmc'
        },
        {
          type: 'input',
          label: '证书编码',
          key: 'code'
        },
        {
          type: 'input',
          label: '发证机关',
          key: 'issueOrg'
        },
        {
          type: 'input',
          label: '签发人',
          key: 'issueUser'
        },
        {
          type: 'datePicker',
          label: '发证日期',
          key: 'getDate'
        },
        {
          type: 'input',
          label: '毕业学校',
          key: 'gradSchool'
        },
        {
          type: 'input',
          label: '专业',
          key: 'pro'
        },
        {
          type: 'input',
          label: '类别',
          key: 'mType'
        }]
        return data
      }
    }
  }
}
</script>
